import dayjs from "dayjs";
import { useDetailActualData } from "../../../hooks/useDetailActualData";
import S from "./index.module.scss";
import Image from "next/image";

const DetailActualText = () => {
  const { detailActual, isLoading } = useDetailActualData();

  if (!detailActual || isLoading) return null;

  return (
    <div className={S.content}>
      <div className={S.textWrapper}>
        <h1 className={S.title}>{detailActual.title}</h1>
        <p className={S.date}>{dayjs(detailActual.date_publication).format("DD.MM.YYYY")}</p>
        <div className={S.desc} dangerouslySetInnerHTML={{ __html: detailActual.description }} />
      </div>
      <Image className={S.preview} src={detailActual.preview_image} alt="preview" width={660} height={660} />
    </div>
  );
};

export default DetailActualText;
